import { Command } from 'enums';
import { axiosAPI } from './API';
import { ICommandResponse } from 'interfaces';

// Singleton for commanding devices
class _CommandService {

    public commandDevice = (thingID: string, command: Command, commandValue: string): Promise<ICommandResponse> => {
        let payload = {
            thingID: thingID, 
            command: command, 
            commandValue: commandValue
        }

        const p = axiosAPI.post<ICommandResponse>('/command', payload)
            .then((resp) => {
                return resp.data;
            });

        p.catch((err) => {
            console.error('Error commanding device: ', err);
        });

        return p;
    }
}

export const CommandService = new _CommandService();